<template>
  <div>
    <section class="container-fluid my-4">
      <h4 class="my-4">Relação de todos os <strong>Polos</strong></h4>

      <div class="well mb-4">
        <input
          type="text"
          class="form-control"
          placeholder="Filtrar a lista abaixo"
          v-model="search"
        />
      </div>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th><a href="#" @click="sort($event, 'id')">#</a></th>
            <th><a href="#" @click="sort($event, 'name')">Nome</a></th>

            <th>Cidade</th>
            <th>Responsável</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th>Criado</th>
            <th width="98px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name | uppercase}}</td>

            <td>{{ item.city | uppercase }}</td>
            <td>{{ item.responsible | uppercase }}</td>
            <td>{{ item.email | lowercase }}</td>
            <td>
              
              <button
                v-if="item.phone"
                type="button"
                class="btn btn-sm btn-success ms-2"
                @click="openWhatsApp(item.phone)"
                title="Abrir conversa no WhatsApp"
              >
                {{ item.phone || '-' }}
              </button>
            </td>

            <td>{{ item.created_at }}</td>
            <td>
              <ButtonEdit :to="{ name: 'polo-edit', params: { id: item.id } }"/>
              <ButtonDelete @delete="handlerDelete(item.id, 'disciplines')"/>
            </td>
          </tr>
        </tbody>
      </table>

      <Pagination :source="pagination" @navigate="navigate" />
    </section>
  </div>
</template>
  
  <script>
import api from "@/services";
import Pagination from "@/components/Pagination.vue";
import ButtonEdit from "@/components/ButtonEdit.vue";
import ButtonDelete from "@/components/ButtonDelete.vue";
import { serialize, handlerDelete } from "@/helpers";

export default {
  name: "PoloList",
  components: {
    Pagination,
    ButtonEdit,
    ButtonDelete
  },
  data() {
    return {
      sortProperty: "id",
      sortDirection: 1,
      search: "",
      pagination: {},
      items: [],
      handlerDelete
    };
  },
  methods: {
    openWhatsApp(phone) {
      if (!phone) {
        Toast.fire("Aviso", "Nenhum telefone cadastrado", "warning");
        return;
      }

      // Remove todos os caracteres não numéricos do telefone
      const phoneNumber = phone.replace(/\D/g, '');
      
      if (phoneNumber.length < 10) {
        Toast.fire("Aviso", "Número de telefone inválido", "warning");
        return;
      }

      // Adiciona o código do país (55 para Brasil) se não tiver
      const fullNumber = phoneNumber.startsWith('55') ? phoneNumber : `55${phoneNumber}`;
      
      // Monta a URL do WhatsApp com uma mensagem padrão
      const message = encodeURIComponent('Saudações! Aqui é da equipe da Paideia Educacional');
      const whatsappUrl = `https://web.whatsapp.com/send?phone=${fullNumber}&text=${message}`;
      
      // Abre em uma nova aba
      window.open(whatsappUrl, '_blank');
    },
    sort(ev, property) {
      ev.preventDefault();
      this.sortProperty = property;

      this.sortDirection = this.sortDirection ? 0 : 1;

      this.getItens();
    },
    navigate(page) {
      this.getItens(page);
    },
    async getItens(page = 1) {
      let query = serialize({
        search: this.search,
        sortDesc: this.sortDirection,
        sortBy: this.sortProperty,
      });

      let uri = `/polos?page=${page}` + query;

      await api.get(uri).then((res) => {
        this.items = res.data.data;
        this.pagination = res.data;
      });
    },
  },
  mounted() {
    this.getItens();
  },
  watch: {
    async search(ev) {
      this.getItens();
    },
  },
};
</script>
  
  <style scoped>
</style>